export default "__VITE_ASSET__BiT1fKSN__"